import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuthToken } from '../../utils/authToken';

export const ProtectedRoute = ({ children }) => {
    if (getAuthToken()) {
        return <>{children}</>;
    }
    return <Navigate to="/login" replace />;
};

export const UnprotectedRoute = ({ children }) => {
    if (!getAuthToken()) {
        return <>{children}</>;
    }
    return <Navigate to="/dashboard" replace />;
};
